<template>
<div class="chapter">
<div class="inner_page">
<div class="mike" id="pgepubid00000">
<h1 class="sigilnotintoc">MIKE</h1>
<h1 class="sigilnotintoc">A PUBLIC SCHOOL STORY</h1>
<h1 class="sigilnotintoc">BY</h1>
<div class="calibre1">
<h2 class="sigilnotintoc1" id="pgepubid00003">P. G. WODEHOUSE</h2>
<h4 class="sigilnotintoc2" id="pgepubid00004">AUTHOR OF "THE GOLD BAT," "A PREFECT'S UNCLE," ETC.</h4>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?1abdbb8a